// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CampaignPreviewController from "./campaign_preview_controller"
application.register("campaign-preview", CampaignPreviewController)

import CartController from "./cart_controller"
application.register("cart", CartController)

import CartItemController from "./cart_item_controller"
application.register("cart-item", CartItemController)

import CategorySwiperController from "./category_swiper_controller"
application.register("category-swiper", CategorySwiperController)

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import CurrencyInputController from "./currency_input_controller"
application.register("currency-input", CurrencyInputController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import EditableRowController from "./editable_row_controller"
application.register("editable-row", EditableRowController)

import FaqsController from "./faqs_controller"
application.register("faqs", FaqsController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import HeaderDropdownController from "./header_dropdown_controller"
application.register("header-dropdown", HeaderDropdownController)

import ImageDropzoneController from "./image_dropzone_controller"
application.register("image-dropzone", ImageDropzoneController)

import LanguageTabsController from "./language_tabs_controller"
application.register("language-tabs", LanguageTabsController)

import LineChartController from "./line_chart_controller"
application.register("line-chart", LineChartController)

import PhoneController from "./phone_controller"
application.register("phone", PhoneController)

import PhotoStackController from "./photo_stack_controller"
application.register("photo-stack", PhotoStackController)

import ProductController from "./product_controller"
application.register("product", ProductController)

import ProductLightboxController from "./product_lightbox_controller"
application.register("product-lightbox", ProductLightboxController)

import ProductSwiperController from "./product_swiper_controller"
application.register("product-swiper", ProductSwiperController)

import ProductsFilterController from "./products_filter_controller"
application.register("products-filter", ProductsFilterController)

import ScrollToMeController from "./scroll_to_me_controller"
application.register("scroll-to-me", ScrollToMeController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SegmentSaveController from "./segment_save_controller"
application.register("segment-save", SegmentSaveController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import SpecsFieldsController from "./specs_fields_controller"
application.register("specs-fields", SpecsFieldsController)

import StoriesSlideshowController from "./stories_slideshow_controller"
application.register("stories-slideshow", StoriesSlideshowController)

import SubscriptionModalController from "./subscription_modal_controller"
application.register("subscription-modal", SubscriptionModalController)

import SubscriptionSetupController from "./subscription_setup_controller"
application.register("subscription-setup", SubscriptionSetupController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)
